// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__1xGEd","col":"Table_col__3Db28","fulfillmentStatus":"Table_fulfillmentStatus__KrFP2","emailCol":"Table_emailCol__1H7_4"};